import { render } from "./index.vue?vue&type=template&id=ab87da84&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ab87da84&scoped=true&lang=css"

import exportComponent from "/opt/server_deploy/hnyj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab87da84"]])

export default __exports__